var n = /* @__PURE__ */ ((i) => (i.fill = "fill", i.fillLight = "fillLight", i.outline = "outline", i.outlineLight = "outlineLight", i))(n || {});
const s = Symbol("pinInput"), e = (i) => {
  switch (i) {
    case "fill":
      return "pin-input-field";
    case "fillLight":
      return "pin-input-field-light";
    case "outline":
      return "";
    case "outlineLight":
      return "pin-input-field-outline-light";
    default:
      return "";
  }
}, u = (i) => {
  const t = i.invalid ? "input-invalid" : "", l = i.disabled ? "input-disabled" : "";
  return `${t} ${l}`;
}, a = (i) => {
  const t = e(i.variant), l = i.invalid ? "pin-input-invalid" : "";
  return `${t} ${l}`;
};
export {
  n as EPinInputVariant,
  s as PinInputSymbol,
  u as getPinInputContainerStyleClasses,
  a as getPinInputStyleClasses,
  e as getPinInputVariantClass
};
